import { Box, Code } from "@mantine/core";

export function CodeBox(props: { codeText: { command: string, subCommand: string, input: string } }) {
    return (
        <Box
            bg="#0A1C22"
            style={{
                '--radius': '0.2rem',
                borderRadius: '100px',
                padding: '0.5rem',
                maxWidth: '100%',
                overflow: 'hidden'
            }}
        >
            <Code
                block
                bg="#0A1C22"
                color="#0A1C22"
                style={{
                    display: 'flex',
                    gap: '0.3rem',
                    fontSize: '1rem',
                    borderRadius: '100px',
                    overflow: 'hidden',
                }}
            >
                <Code c="pink" style={{ padding: 0, fontSize: '1rem' }}>
                    {props.codeText.command}
                </Code>{" "}
                <Code c="grape" style={{ padding: 0, fontSize: '1rem' }}>
                    {props.codeText.subCommand}
                </Code>{" "}
                <Code c="cyan" style={{ padding: 0, fontSize: '1rem' }}>
                    {props.codeText.input}
                </Code>
            </Code>
        </Box>
    );
}
